"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var empty_state_svg_1 = __importDefault(require("@assets/components/user/empty-state/empty-state.svg"));
var CreateButton_1 = __importDefault(require("./CreateButton"));
var useState = core_1.makeStyles(function (theme) {
    var _a, _b;
    return core_1.createStyles({
        emptyStateContainer: (_a = {
                width: 'unset',
                paddingTop: function (props) { return (!props.urlsFiltered ? 45 : 26); },
                paddingBottom: 78,
                backgroundColor: '#F4F7FA'
            },
            _a[theme.breakpoints.up('md')] = {
                paddingTop: function (props) { return (!props.urlsFiltered ? 85 : 45); },
                paddingBottom: function (props) {
                    return !props.urlsFiltered ? 85 : 45;
                },
            },
            _a),
        paper: (_b = {
                maxWidth: 300,
                margin: 'auto',
                paddingTop: function (props) { return (!props.urlsFiltered ? 45 : 26); },
                paddingBottom: 78,
                paddingLeft: 10,
                paddingRight: 10
            },
            _b[theme.breakpoints.up('sm')] = {
                maxWidth: 600,
                margin: 'auto',
                paddingTop: function (props) { return (!props.urlsFiltered ? 85 : 45); },
                paddingBottom: function (props) {
                    return !props.urlsFiltered ? 85 : 45;
                },
            },
            _b[theme.breakpoints.up('lg')] = {
                maxWidth: 1428,
            },
            _b),
        headerText: {
            lineHeight: '25px',
            marginBottom: 0,
            fontWeight: 400,
            '&:last-child': {
                marginBottom: 20,
            },
        },
        emptyStateGraphic: {
            display: 'block',
            margin: 'auto',
            maxWidth: 200,
            marginBottom: 20,
        },
        createButtonDiv: {
            display: 'flex',
            justifyContent: 'center',
        },
    });
});
var EmptyState = function (_a) {
    var urlsFiltered = _a.urlsFiltered;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useState({ urlsFiltered: urlsFiltered });
    return (react_1.default.createElement("div", { className: classes.emptyStateContainer },
        react_1.default.createElement(core_1.Paper, { elevation: 0, className: classes.paper },
            react_1.default.createElement("img", { className: classes.emptyStateGraphic, src: empty_state_svg_1.default, alt: "No shortened links yet", draggable: false }),
            react_1.default.createElement("div", null,
                urlsFiltered && (react_1.default.createElement(core_1.Typography, { className: classes.headerText, align: "center", variant: "body2", color: "textPrimary" }, t('text.noResultSearchFound'))),
                !urlsFiltered && (react_1.default.createElement(core_1.Typography, { className: classes.headerText, align: "center", variant: "body2", color: "textPrimary" }, t('text.noShortenLink'))),
                !urlsFiltered && (react_1.default.createElement(core_1.Typography, { className: classes.headerText, align: "center", variant: "body2", color: "textPrimary" }, t('text.getStartedAndCustomise')))),
            !urlsFiltered && (react_1.default.createElement("div", { className: classes.createButtonDiv },
                react_1.default.createElement(CreateButton_1.default, null))))));
};
exports.default = EmptyState;
